<div class="height-700">
  <nz-back-top></nz-back-top>
  Scroll down to see the bottom-right
  <strong> gray </strong>
  button.
</div>
